// extracted by mini-css-extract-plugin
export default {"box":"InfoBox_box__7D9kT","numberBox":"InfoBox_numberBox__EpEEX","textBox":"InfoBox_textBox__wbsox"};